import { SET_JOBS, SET_TASKS, SET_SELECTED_JOBS } from "./types";

const state = {
  jobs: [],
  tasks: [],
  selectedJob: null
};

const mutations = {
  [SET_JOBS](state, jobs) {
    state.jobs = jobs;
  },
  [SET_SELECTED_JOBS](state, job) {
    state.selectedJob = job;
  },
  [SET_TASKS](state, tasks) {
    state.tasks = tasks;
  }
};

import * as getters from "./getters";
import * as actions from "./actions";

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
